import { request } from './httpService';

export const getShareData = id => {
    const path = `/users/me/clips/${id}`;

    return request(path);
};

export const getEventData = id => {
    const path = `/events/${id}`;

    return request(path);
};

export const getEventHighlightData = id => {
    const path = `/events/highlights/${id}`;

    return request(path);
};

export const getPlayerHighlightData = id => {
    const path = `/player-highlights/${id}`;

    return request(path);
};
export const getPlayerTimeStampFromUnix = (eventId, unixTimeStampInMilliseconds) => {
    const path = `/video-timestamps/events/${eventId}/videoTimestamps/hd/vod/ptsFromTs/${unixTimeStampInMilliseconds}`;

    return request(path);
};

export const getEventPlayerHighlights = (eventId, source) => {
    let path = `/player-highlights/event/${eventId}?limit=100&sort=team.color`;

    if (source) {
        path += `&source=${source}`;
    }

    return request(path);
};
